import styled from "@emotion/styled";
import React from "react";
import Info from "../components/Info";

const StyledContainer = styled.div`
    .style-wrap {
        .title {
            // font-size: 5.2vw;
            font-size: clamp(24px, 3.38vw, 65px);
            color: #fff;

            transition: color 0.5s;

            @media screen and (max-width: 1055px) {
                line-height: 1.5;
                font-size: 22px;

                height: 17vh;

                .no-touch-screen & {
                    min-height: 14vh;
                    height: max-content;
                }

                .touch-screen & {
                    height: 14vh;
                }
            }
        }

        .input-container {
            height: 50vh;
            min-height: 50vh;
            max-height: 50vh;
            border-radius: 34px;
            width: 50vw;
            max-width: 780px;
            flex: unset;
            padding: 50px;

            background: #fff;

            @media screen and (max-width: 1055px) {
                max-width: unset;
                width: 100%;
                padding: 30px 25px;
                min-height: unset;
                height: calc(100% - 120px - 8vh);
                border-radius: 17px;

                max-height: unset;
            }

            @media screen and (max-width: 375px) {
                height: calc(100% - 135px);
            }

            .info-container {
                padding-right: 30px;

                @media screen and (max-width: 1055px) {
                    padding-right: 20px;
                }
            }
        }
    }
`;

const CheckInformationView = ({ type }) => {
    return (
        <StyledContainer className="style-container" data-info data-line data-step="7">
            <div className="style-wrap">
                <div className="title">
                    <div className="step">
                        <span className="current">{type === 0 ? 6 : 4}</span>
                        <span className="line"></span>
                        <span className="total">{type === 0 ? 6 : 4}</span>
                    </div>
                    <div>
                        작성하신 의뢰서를 <br />
                        PlusX에 전달할까요?
                    </div>
                </div>
                <div className="input-container">
                    <Info />
                </div>
            </div>
        </StyledContainer>
    );
};

export default React.memo(CheckInformationView);
